import { useMemo } from 'react'
import { LAYER_TYPES, useLayerType } from '~map-preview/states/layerType'
import { useMap, useNumericProperties } from '~map-preview/states/map'
import { mapAggregateProperties } from '~map-preview/utils/mapAggregateProperties'

export const useMapDataWithAggregateProperties = () => {
  const mapData = useMap()
  const layerType = useLayerType()
  const numericProperties = useNumericProperties()
  const properties = useMemo(
    () => mapAggregateProperties(numericProperties),
    [numericProperties]
  )

  const aggregateLayerTypes = [LAYER_TYPES.HEXAGON, LAYER_TYPES.BOUNDARIES]

  if (aggregateLayerTypes.includes(layerType)) {
    return { ...mapData, properties }
  }

  return mapData
}
